import { Button, message } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import { changeMapLayer, resetMapLayer } from "../../../redux/actions/map.action";
import {
  changeSetting,
  changeManage,
  changeChart,
  changeMenu,
  showMenuPopup,
  showMapLayer,
  onResetLayerAll,
} from "../../../redux/actions/menu.action";
import { LocalStore } from "../../../utils/LocalStore";
import ModalCustom from "../../CustomsAntd/ModalCustom/ModalCustom";
import ModalWarning from "../../CustomsAntd/ModalWarning";

import Popup from "../Menu/Popup";

class MenuLogged extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // typeRender: "default",
      typeRender: "mini",

      isOpenPopup: false,
      popupType: undefined,

      isShowSetting: this.props.isShowSetting,
      isShowManage: this.props.isShowManage,
      isShowChart: this.props.isShowChart,
      // state menu

      // he thong
      QuanLyHeThong: false,
      QuanLyNguoiDung: false,
      QuanLyNhomNguoiDung: false,
      NhatKyHoatDong: false,

      // quy hoach
      QuanLyQuyHoach: false,
      QuyHoachChiTiet: false,
      QuyHoachPhanKhu: false,
      QuyHoachChung: false,
      QuyHoachKienTruc: false,

      // bieu do
      BieuDo: false,
      BieuDo500: false,
      BieuDo5000: false,
      BieuDo10000: false,

      //

      GioiThieu: false,
      HuongDan: false,

      // logout
      isVisiableModalLogout: false,
    };
  }

  componentDidMount() {
    this.checkEnableMenu();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.isShowSetting !== this.props.isShowSetting) {
      this.setState({
        isShowSetting: this.props.isShowSetting,
      });
    }

    if (prevProps.isShowManage !== this.props.isShowManage) {
      this.setState({
        isShowManage: this.props.isShowManage,
      });
    }

    if (prevProps.isShowChart !== this.props.isShowChart) {
      this.setState({
        isShowChart: this.props.isShowChart,
      });
    }

    if (prevProps.isShowMenuPopup !== this.props.isShowMenuPopup) {
      this.setState({
        isOpenPopup: this.props.isShowMenuPopup,
      });
    }
  }

  checkEnableMenu() {
    let path = this.props.history.location.pathname;
    switch (path) {
      // ql he thong
      // ng dung
      case "/ql-nguoi-dung":
        this.props.changeSetting(true);
        this.props.showMapLayer(false);
        this.setState({
          QuanLyNguoiDung: true,
          QuanLyHeThong: true,
          isShowSetting: true,
        });
        break;

      case "/ql-nguoi-dung/tao-moi":
        this.props.changeSetting(true);
        this.props.showMapLayer(false);
        this.setState({
          QuanLyNguoiDung: true,
          QuanLyHeThong: true,
          isShowSetting: true,
        });
        break;

      // phong ban
      case "/ql-nhom-nguoi-dung":
        this.props.changeSetting(true);
        this.props.showMapLayer(false);
        this.setState({
          QuanLyNhomNguoiDung: true,
          QuanLyHeThong: true,
          isShowSetting: true,
        });
        break;

      case "/ql-nhom-nguoi-dung/tao-moi":
        this.props.changeSetting(true);
        this.props.showMapLayer(false);
        this.setState({
          QuanLyNhomNguoiDung: true,
          QuanLyHeThong: true,
          isShowSetting: true,
        });
        break;

      // nhat ky
      case "/nhat-ky":
        this.props.changeSetting(true);
        this.props.showMapLayer(false);
        this.setState({
          QuanLyHeThong: true,
          NhatKyHoatDong: true,
          isShowSetting: true,
        });
        break;

      // quy hoach kien truc
      case "/ql-quy-hoach-chi-tiet":
        this.props.changeManage(true);
        this.props.showMapLayer(false)
        this.setState({
          QuanLyQuyHoach: true,
          QuyHoachChiTiet: true,
          isShowManage: true,
        });
        break;

      case "/ql-quy-hoach-phan-khu":
        this.props.changeManage(true);
        this.props.showMapLayer(false)
        this.setState({
          QuanLyQuyHoach: true,
          QuyHoachPhanKhu: true,
          isShowManage: true,
        });
        break;

      case "/ql-quy-hoach-chung":
        this.props.changeManage(true);
        this.props.showMapLayer(false)
        this.setState({
          QuanLyQuyHoach: true,
          QuyHoachChung: true,
          isShowManage: true,
        });
        break;

      case "/ql-quy-hoach-kien-truc":
        this.props.changeManage(true);
        this.props.showMapLayer(false)
        this.setState({
          QuanLyQuyHoach: true,
          QuyHoachKienTruc: true,
          isShowManage: true,
        });
        break;

      // bieu do

      case "/thong-ke-tong-hop":
        this.props.changeChart(true);
        this.props.showMapLayer(false);
        this.setState({
          BieuDo: true,
          BieuDoThongKe: true,
          isShowChart: true,
        });
        break;

      case "/thong-ke-quy-hoach-chi-tiet":
        this.props.changeChart(true);
        this.props.showMapLayer(false);
        this.setState({
          BieuDo: true,
          BieuDo500: true,
          isShowChart: true,
        });
        break;

      case "/thong-ke-quy-hoach-phan-khu":
        this.props.changeChart(true);
        this.props.showMapLayer(false);
        this.setState({
          BieuDo: true,
          BieuDo5000: true,
          isShowChart: true,
        });
        break;

      case "/thong-ke-quy-hoach-chung":
        this.props.changeChart(true);
        this.props.showMapLayer(false);
        this.setState({
          BieuDo: true,
          BieuDo10000: true,
          isShowChart: true,
        });
        break;

      default:
        break;
    }

    if (path.includes("ql-nguoi-dung") && path.includes("chinh-sua")) {
      this.props.changeSetting(true);
      this.props.showMapLayer(false);
      this.setState({
        QuanLyNguoiDung: true,
        QuanLyHeThong: true,
        isShowSetting: true,
      });
    }

    if (path.includes("ql-nhom-nguoi-dung") && path.includes("chinh-sua")) {
      this.props.changeSetting(true);
      this.props.showMapLayer(false);
      this.setState({
        QuanLyNhomNguoiDung: true,
        QuanLyHeThong: true,
        isShowSetting: true,
      });
    }
  }

  explandMenu(type) {
    this.setState({
      typeRender: this.state.typeRender === "default" ? "mini" : "default",
    });
    this.props.changeMenu(type === 'open');
  }

  // --------------------handle-menu--------------------

  handleOpenSetting() {
    this.props.changeSetting(!this.props.isShowSetting);
    this.props.changeManage(false);
    this.props.changeChart(false);
  }

  handleOpenManage() {
    this.props.changeManage(!this.props.isShowManage);
    this.props.changeSetting(false);
    this.props.changeChart(false);
  }

  handleOpenBieuDo() {
    this.props.changeChart(!this.props.isShowChart);
    this.props.changeManage(false);
    this.props.changeSetting(false);
  }

  handleClickIntroduce = () => {
    this.setState({
      isOpenPopup: true,
      popupType: "introduce",
      GioiThieu: true,
      HuongDan: false,
    });
    this.props.showMenuPopup(true);
  };

  handleClickTutorial = () => {
    this.setState({
      isOpenPopup: true,
      popupType: "tutorial",
      HuongDan: true,
      GioiThieu: false,
    });
    this.props.showMenuPopup(true);
  };

  handleClosePopup = () => {
    this.setState({
      isOpenPopup: false,
      popupType: undefined,
      GioiThieu: false,
      HuongDan: false,
    });
  };

  handleOpenModalLogout = () => {
    this.setState({
      isVisiableModalLogout: true,
    });
  };

  handleCloseModalLogout = () => {
    this.setState({
      isVisiableModalLogout: false,
    });
  };

  onLogout = () => {
    LocalStore.getInstance().save("loginSession", null);
    LocalStore.getInstance().save("loginRole", null);
    LocalStore.getInstance().save("loginPermission", null);
    LocalStore.getInstance().save("loginListRole", null);
    LocalStore.getInstance().save("loginMaPhuongXa", null);
    localStorage.clear();
    this.props.history.push("/");
    window.location.reload();
    this.props.disconnectSocket(true);
  };

  checkPermission(arr) {
    let check = false;
    arr.forEach((e) => {
      if (this.props.permission == e) {
        check = true;
        return check;
      }
    });
    return check;
  }

  render() {
    return (
      <div className="menu">
        {this.state.typeRender === "default" ? (
          <div className="default-menu">
            <div className="default-menu-left-col">
              {/* Quan ly quy hoach */}
              {this.checkPermission([
                "QuanTri",
                "LanhDao",
                "ChuyenVien",
                "Khac",
              ]) && (
                <>
                  {this.state.QuanLyQuyHoach ? (
                    <div
                      className="menu-item-active"
                      onClick={() => {
                        this.handleOpenManage();
                      }}
                    >
                      <i className="fas fa-tasks icon-description"></i>
                      <div className="item-text">
                        Quản lý quy hoạch - Kiến trúc
                      </div>
                    </div>
                  ) : (
                    <div
                      className="menu-item"
                      onClick={() => {
                        this.handleOpenManage();
                      }}
                    >
                      <i className="fas fa-tasks icon-description"></i>
                      <div className="item-text">
                        Quản lý quy hoạch - Kiến trúc
                      </div>
                    </div>
                  )}

                  {this.state.isShowManage ? (
                    <div className="sub-menu">
                      {this.state.QuyHoachChiTiet ? (
                        <div className="sub-menu-item-large-active">
                          <i className="fas fa-th-large icon-description"></i>
                          <div>
                            <div className="sub-item-text-large-active">
                              Quản lý dự án quy hoạch
                            </div>
                            <div className="sub-item-text-large-active">
                              chi tiết 1/500
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div
                          className="sub-menu-item-large"
                          onClick={() => {
                            this.explandMenu('close');
                            this.props.history.push("/ql-quy-hoach-chi-tiet");
                          }}
                        >
                          <i className="fas fa-th-large icon-description"></i>
                          <div>
                            <div className="sub-item-text-large">
                              Quản lý dự án quy hoạch
                            </div>
                            <div className="sub-item-text-large">
                              chi tiết 1/500
                            </div>
                          </div>
                        </div>
                      )}

                      {this.state.QuyHoachPhanKhu ? (
                        <div className="sub-menu-item-large-active">
                          <i className="fas fa-th-list icon-description"></i>
                          <div>
                            <div className="sub-item-text-large-active">
                              Quản lý dự án quy hoạch
                            </div>
                            <div className="sub-item-text-large-active">
                              phân khu 1/5000
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div
                          className="sub-menu-item-large"
                          onClick={() => {
                            this.explandMenu('close');
                            this.props.history.push("/ql-quy-hoach-phan-khu");
                          }}
                        >
                          <i className="fas fa-th-list icon-description"></i>
                          <div>
                            <div className="sub-item-text-large">
                              Quản lý dự án quy hoạch
                            </div>
                            <div className="sub-item-text-large">
                              phân khu 1/5000
                            </div>
                          </div>
                        </div>
                      )}

                      {this.state.QuyHoachChung ? (
                        <div className="sub-menu-item-large-active">
                          <i className="fas fa-th icon-description"></i>
                          <div>
                            <div className="sub-item-text-large-active">
                              Quản lý quy hoạch chung
                            </div>
                            <div className="sub-item-text-large-active">
                              1/10000
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div
                          className="sub-menu-item-large"
                          onClick={() => {
                            this.explandMenu('close');
                            this.props.history.push("/ql-quy-hoach-chung");
                          }}
                        >
                          <i className="fas fa-th icon-description"></i>
                          <div>
                            <div className="sub-item-text-large">
                              Quản lý quy hoạch chung
                            </div>
                            <div className="sub-item-text-large">1/10000</div>
                          </div>
                        </div>
                      )}

                      {this.state.QuyHoachKienTruc ? (
                        <div className="sub-menu-item-active">
                          <i className="fas fa-place-of-worship icon-description"></i>
                          <div className="sub-item-text-active">
                            Quản lý kiến trúc
                          </div>
                        </div>
                      ) : (
                        <div
                          className="sub-menu-item"
                          onClick={() => {
                            this.explandMenu('close');
                            this.props.history.push("/ql-quy-hoach-kien-truc");
                          }}
                        >
                          <i className="fas fa-place-of-worship icon-description"></i>
                          <div className="sub-item-text">Quản lý kiến trúc</div>
                        </div>
                      )}
                    </div>
                  ) : null}
                </>
              )}

              {/* Bieu do thong ke */}
              {this.checkPermission(["QuanTri", "LanhDao", "ChuyenVien"]) && (
                <>
                  {this.state.BieuDo ? (
                    <div
                      className="menu-item-active"
                      onClick={() => {
                        this.handleOpenBieuDo();
                      }}
                    >
                      <i className="fas fa-file-contract icon-description"></i>
                      <div className="item-text">Biểu đồ - Thống kê</div>
                    </div>
                  ) : (
                    <div
                      className="menu-item"
                      onClick={() => {
                        this.handleOpenBieuDo();
                      }}
                    >
                      <i className="fas fa-file-contract icon-description"></i>
                      <div className="item-text">Biểu đồ - Thống kê</div>
                    </div>
                  )}

                  {this.state.isShowChart ? (
                    <div className="sub-menu">
                      {this.state.BieuDoThongKe ? (
                        <div className="sub-menu-item-active">
                          <i className="fas fa-chart-line icon-description"></i>
                          <div className="sub-item-text-active">
                            Thống kê tổng hợp
                          </div>
                        </div>
                      ) : (
                        <div
                          className="sub-menu-item"
                          onClick={() => {
                            this.explandMenu('close');
                            this.props.history.push("/thong-ke-tong-hop");
                          }}
                        >
                          <i className="fas fa-chart-line icon-description"></i>
                          <div className="sub-item-text">Thống kê tổng hợp</div>
                        </div>
                      )}

                      {this.state.BieuDo500 ? (
                        <div className="sub-menu-item-large-active">
                          <i className="fas fa-chart-line icon-description"></i>
                          <div>
                            <div className="sub-item-text-large-active">
                              Thống kê chi tiết quy
                            </div>
                            <div className="sub-item-text-large-active">
                              hoạch chi tiết 1/500
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div
                          className="sub-menu-item-large"
                          onClick={() => {
                            this.explandMenu('close');
                            this.props.history.push(
                              "/thong-ke-quy-hoach-chi-tiet"
                            );
                          }}
                        >
                          <i className="fas fa-chart-line icon-description"></i>
                          <div>
                            <div className="sub-item-text-large">
                              Thống kê chi tiết quy
                            </div>
                            <div className="sub-item-text-large">
                              hoạch chi tiết 1/500
                            </div>
                          </div>
                        </div>
                      )}

                      {this.state.BieuDo5000 ? (
                        <div className="sub-menu-item-large-active">
                          <i className="fas fa-chart-line icon-description"></i>
                          <div>
                            <div className="sub-item-text-large-active">
                              Thống kê chi tiết quy
                            </div>
                            <div className="sub-item-text-large-active">
                              hoạch phân khu 1/5000
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div
                          className="sub-menu-item-large"
                          onClick={() => {
                            this.explandMenu('close');
                            this.props.history.push(
                              "/thong-ke-quy-hoach-phan-khu"
                            );
                          }}
                        >
                          <i className="fas fa-chart-line icon-description"></i>
                          <div>
                            <div className="sub-item-text-large">
                              Thống kê chi tiết quy
                            </div>
                            <div className="sub-item-text-large">
                              hoạch phân khu 1/5000
                            </div>
                          </div>
                        </div>
                      )}

                      {this.state.BieuDo10000 ? (
                        <div className="sub-menu-item-large-active">
                          <i className="fas fa-chart-line icon-description"></i>
                          <div>
                            <div className="sub-item-text-large-active">
                              Thống kê chi tiết quy
                            </div>
                            <div className="sub-item-text-large-active">
                              hoạch chung 1/10000
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div
                          className="sub-menu-item-large"
                          onClick={() => {
                            this.explandMenu('close');
                            this.props.history.push(
                              "/thong-ke-quy-hoach-chung"
                            );
                          }}
                        >
                          <i className="fas fa-chart-line icon-description"></i>
                          <div>
                            <div className="sub-item-text-large">
                              Thống kê chi tiết quy
                            </div>
                            <div className="sub-item-text-large">
                              hoạch chung 1/10000
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  ) : null}
                </>
              )}

              {/* Quan ly he thong */}
              {this.checkPermission(["QuanTri"]) && (
                <>
                  {this.state.QuanLyHeThong ? (
                    <div
                      className="menu-item-active"
                      onClick={() => {
                        this.handleOpenSetting();
                      }}
                    >
                      <i className="fas fa-cog icon-description"></i>
                      <div className="item-text">Quản lý hệ thống</div>
                    </div>
                  ) : (
                    <div
                      className="menu-item"
                      onClick={() => {
                        this.handleOpenSetting();
                      }}
                    >
                      <i className="fas fa-cog icon-description"></i>
                      <div className="item-text">Quản lý hệ thống</div>
                    </div>
                  )}

                  {this.state.isShowSetting ? (
                    <div className="sub-menu">
                      {this.state.QuanLyNguoiDung ? (
                        <div
                          className="sub-menu-item-active"
                          onClick={() => {
                            this.explandMenu('close');
                            this.props.history.push("/ql-nguoi-dung");
                          }}
                        >
                          <i className="fas fa-user icon-description"></i>
                          <div className="sub-item-text-active">
                            Quản lý người dùng
                          </div>
                        </div>
                      ) : (
                        <div
                          className="sub-menu-item"
                          onClick={() => {
                            this.explandMenu('close');
                            this.props.history.push("/ql-nguoi-dung");
                          }}
                        >
                          <i className="fas fa-user icon-description"></i>
                          <div className="sub-item-text">
                            Quản lý người dùng
                          </div>
                        </div>
                      )}

                      {this.state.QuanLyNhomNguoiDung ? (
                        <div
                          className="sub-menu-item-active"
                          onClick={() => {
                            this.explandMenu('close');
                            this.props.history.push("/ql-nhom-nguoi-dung");
                          }}
                        >
                          <i className="fas fa-user icon-description"></i>
                          <div className="sub-item-text-active">
                            Quản lý phòng ban
                          </div>
                        </div>
                      ) : (
                        <div
                          className="sub-menu-item"
                          onClick={() => {
                            this.explandMenu('close');
                            this.props.history.push("/ql-nhom-nguoi-dung");
                          }}
                        >
                          <i className="fas fa-user icon-description"></i>
                          <div className="sub-item-text">Quản lý phòng ban</div>
                        </div>
                      )}

                      {this.state.NhatKyHoatDong ? (
                        <div className="sub-menu-item-active">
                          <i className="fas fa-user-clock icon-description"></i>
                          <div className="sub-item-text-active">
                            Nhật ký hoạt động
                          </div>
                        </div>
                      ) : (
                        <div
                          className="sub-menu-item"
                          onClick={() => {
                            this.explandMenu('close');
                            this.props.history.push("/nhat-ky");
                          }}
                        >
                          <i className="fas fa-user-clock icon-description"></i>
                          <div className="sub-item-text">Nhật ký hoạt động</div>
                        </div>
                      )}
                    </div>
                  ) : null}
                </>
              )}

              {/* gioi thieu */}
              <div
                className={
                  this.state.popupType && this.state.popupType === "introduce"
                    ? "menu-item-active"
                    : "menu-item"
                }
                onClick={this.handleClickIntroduce}
              >
                <i className="fas fa-book icon-description" />
                <div className="item-text">Giới thiệu phần mềm</div>
              </div>

              {/* Huong dan*/}
              <div
                className={
                  this.state.popupType && this.state.popupType === "tutorial"
                    ? "menu-item-active"
                    : "menu-item"
                }
                onClick={this.handleClickTutorial}
              >
                <i className="fas fa-file-video icon-description"></i>
                <div className="item-text">Hướng dẫn sử dụng</div>
              </div>

              {/* dang xuat */}
              <div className="menu-item" onClick={this.handleOpenModalLogout}>
                <i className="fas fa-sign-out-alt icon-description"></i>
                <div className="item-text">Đăng xuất</div>
              </div>

              <div className="menu-item" 
                onClick={() => {
                  // this.explandMenu('close');
                  // this.props.resetMapLayer()
                  // this.props.changeMapLayer(["RanhGioiDiaChinh", "BienSoNha"]);
                  this.props.changeMenu(false);
                  this.props.onResetLayerAll();
                  this.props.history.push("/");
                }}
              >
                <i className="fas fa-times-circle icon-description"></i>
                <div className="item-text">Thoát</div>
              </div>

              {/* tai app */}
              <div className="menu-bottom">
                <Button className="download-item" onClick={() => {
                    window.open('https://play.google.com/store/apps/details?id=com.ttqhSoXayDung', "_blank");
                  }}>
                  <img src="/images/IconSvg/Icon/android.png" alt="" />
                  <div className="text-download">
                    <div className="text">Tải ứng dụng </div>
                    <div className="text">hệ điều hành Android</div>
                  </div>
                </Button>

                <Button className="download-item"onClick={() => {
                    window.open('https://apps.apple.com/vn/app/ttqh-%C4%91%C3%A0-n%E1%BA%B5ng/id1559033028?ign-itscg=30200&ign-itsct=apps_box_link#?platform=iphone', "_blank");
                  }}>
                  <img src="/images/IconSvg/Icon/iso.png" alt="" />
                  <div className="text-download">
                    <div className="text">Tải ứng dụng </div>
                    <div className="text">hệ điều hành IOS</div>
                  </div>
                </Button>
              </div>
            </div>

            <div className="resize">
              <div
                className="button-resize"
                onClick={() => {
                  this.explandMenu('close');
                }}
              >
                <i
                  className="fas fa-chevron-circle-left"
                  style={{ fontSize: "24px" }}
                ></i>
              </div>
            </div>
          </div>
        ) : null}

        {this.state.typeRender === "mini" ? (
          <div>
            <div
              className="mini-menu"
             
            >
              <div>
                {this.checkPermission([
                  "QuanTri",
                  "LanhDao",
                  "ChuyenVien",
                  "Khac",
                ]) && (
                  <>
                    <div
                      className={
                        this.state.QuanLyQuyHoach
                          ? "button-menu-active"
                          : "button-menu"
                      }
                      onClick={() => {
                        // this.setState({ typeRender: "default" });
                        // this.props.changeMenu(!this.props.isShowMenu);
                        this.explandMenu('open');
                      }}
                    >
                      <i className="fas fa-tasks icon-description" />
                    </div>
                  </>
                )}

                {this.checkPermission(["QuanTri", "LanhDao", "ChuyenVien"]) && (
                  <>
                    <div
                      className={
                        this.state.BieuDo ? "button-menu-active" : "button-menu"
                      }
                      onClick={() => {
                        // this.setState({ typeRender: "default" });
                        // this.props.changeMenu(!this.props.isShowMenu);
                        this.explandMenu('open');
                      }}
                    >
                      <i className="fas fa-file-contract icon-description" />
                    </div>
                  </>
                )}

                {this.checkPermission(["QuanTri"]) && (
                  <>
                    <div
                      className={
                        this.state.QuanLyHeThong
                          ? "button-menu-active"
                          : "button-menu"
                      }
                      onClick={() => {
                        // this.setState({ typeRender: "default" });
                        // this.props.changeMenu(!this.props.isShowMenu);
                        this.explandMenu('open');
                      }}
                    >
                      <i className="fas fa-cog icon-description" />
                    </div>
                  </>
                )}
                {/* gioi thieu */}
                {this.state.GioiThieu ? (
                  <div
                    className="button-menu-active"
                    onClick={this.handleClosePopup}
                  >
                    <i className="fas fa-book icon-description" />
                  </div>
                ) : (
                  <Button
                    className="button-mini"
                    onClick={this.handleClickIntroduce}
                  >
                    <i className="fas fa-book icon-description" />
                  </Button>
                )}

                {/*  huong dan */}
                {this.state.HuongDan ? (
                  <div
                    className="button-menu-active"
                    onClick={this.handleClosePopup}
                  >
                    <i className="fas fa-file-video icon-description" />
                  </div>
                ) : (
                  <Button
                    className="button-mini"
                    onClick={this.handleClickTutorial}
                  >
                    <i className="fas fa-file-video icon-description" />
                  </Button>
                )}

                <Button
                  className="button-mini"
                  onClick={this.handleOpenModalLogout}
                >
                  <i className="fas fa-sign-out-alt icon-description" />
                </Button>

                <Button
                  className="button-mini"
                  onClick={() => {
                    // this.explandMenu('close');
                    // this.props.changeMapLayer(["RanhGioiDiaChinh", "BienSoNha"]);
                    this.props.changeMenu(false);
                    this.props.onResetLayerAll();
                    this.props.history.push("/");
                  }}
                >
                  <i className="fas fa-times-circle icon-description" />
                </Button>

                {/* tai app */}
                <div className="mini-menu-bottom">
                  <Button className="button-circle"
                    onClick={() => {
                      window.open('https://play.google.com/store/apps/details?id=com.ttqhSoXayDung', "_blank");
                    }}
                  >
                    <img
                      src="/images/IconSvg/Icon/android.png"
                      alt=""
                      style={{ width: "40px", height: "40px" }}
                    />
                  </Button>

                  <Button className="button-circle"
                    onClick={() => {
                      window.open('https://apps.apple.com/vn/app/ttqh-%C4%91%C3%A0-n%E1%BA%B5ng/id1559033028?ign-itscg=30200&ign-itsct=apps_box_link#?platform=iphone', "_blank");
                    }}
                  >
                    <img
                      src="/images/IconSvg/Icon/iso.png"
                      alt=""
                      style={{ width: "40px", height: "40px" }}
                    />
                  </Button>
                </div>
              </div>

              {/* resize */}
              <div className="resize">
                <div
                  className="button-resize"
                  onClick={() => {
                    this.explandMenu('open');
                  }}
                >
                  <i
                    className="fas fa-chevron-circle-right"
                    style={{ fontSize: "24px" }}
                  ></i>
                </div>
              </div>
            </div>
          </div>
        ) : null}

        <ModalCustom
          visible={this.state.isOpenPopup}
          onCancel={this.handleClosePopup}
          width={800}
        >
          <Popup 
            close={this.handleClosePopup}
            type={this.state.popupType} 
            typeMenu={this.state.typeRender}
          />
        </ModalCustom>

        <ModalWarning
          visible={this.state.isVisiableModalLogout}
          title={"Bạn có chắc chắn muốn đăng xuất ?"}
          onOk={this.onLogout}
          onCancel={this.handleCloseModalLogout}
        ></ModalWarning>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isShowSetting: state.menu.isShowSetting,
    isShowManage: state.menu.isShowManage,
    isShowChart: state.menu.isShowChart,
    isShowMenu: state.menu.isShowMenu,
    isShowMenuPopup: state.menu.isShowMenuPopup,
    permission: state.auth.permission,
  };
};

const mapDispatchToProps = {
  changeSetting: changeSetting,
  changeManage: changeManage,
  changeChart: changeChart,
  changeMenu: changeMenu,
  changeMapLayer: changeMapLayer,
  showMenuPopup: showMenuPopup,
  showMapLayer: showMapLayer,
  onResetLayerAll: onResetLayerAll,
  resetMapLayer: resetMapLayer
};

export default connect(mapStateToProps, mapDispatchToProps)(MenuLogged);
